import { DataApiInputParams } from 'src/types/api';
import { appendFormData, Builder, getHeaders, getQueryString } from './utils';

export default (builder: Builder) => {
  return {
    getAddCardUrl: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const url = `billing/get-card-add-session?${getQueryString(
          arg.params
        )}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      }
    }),
    getDashBoardUrl: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const url = `billing/view-stripe-dashboard?${getQueryString(
          arg.params
        )}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      }
    }),
    getBillingPreview: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const url = `billing/preview-invoice?${getQueryString(arg.params)}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      }
    }),
    getProductPrices: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const url = `billing/product-prices?${getQueryString(arg.params)}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      }
    }),
    /** Unified subscription changes (checkout session, tier, billing period, seats) */
    postSubscription: builder.mutation({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        const formData = appendFormData(arg.params);
        const url = `billing/subscription`;
        return fetchWithBQ({
          url,
          method: 'POST',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Billings']
    }),
    /** Add-ons attached to the tenant's subscription */
    getAddOns: builder.query({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        const url = `billing/add-ons?${getQueryString(arg?.params)}`;
        return fetchWithBQ({
          url,
          ...getHeaders(url)
        });
      },
      providesTags: ['Billings']
    }),
    /** Purchase an add-on, or reactivate one cancelled within its paid period */
    postAddOn: builder.mutation({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        const formData = appendFormData(arg.params);
        const url = `billing/add-ons`;
        return fetchWithBQ({
          url,
          method: 'POST',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Billings']
    }),
    /** Cancel an add-on at the end of the current period */
    deleteAddOn: builder.mutation({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        const formData = appendFormData(arg.params);
        const url = `billing/add-ons`;
        return fetchWithBQ({
          url,
          method: 'DELETE',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Billings']
    }),
    getBillingInfo: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const url = `billing/billing-info?${getQueryString(arg.params)}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      },
      providesTags: ['Billings']
    }),
    getRenewSubscription: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const url = `billing/get-renew-subscription-session?${getQueryString(
          arg.params
        )}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      }
    })
  };
};
